var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide l-bg"},[_c('div',{staticClass:"start-pos size"},[_c('div',{staticClass:"d-inline"},[_c('h2',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 10000,
        easing: 'easeInOutSine',
        delay: 500,
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 10000,\n        easing: 'easeInOutSine',\n        delay: 500,\n        loop: true,\n      }"}]},[_vm._v("Musican")]),_c('h2',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Soccer Player")])]),_c('div',{staticClass:"d-inline"},[_c('h3',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        delay: 1500,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        delay: 1500,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Problem Solver")])]),_c('div',{staticClass:"d-inline"},[_c('h3',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        delay:2000,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        delay:2000,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Imaginative")])]),_c('h2',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        delay: 2500,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        delay: 2500,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Avid Reader")]),_c('h3',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        delay:500,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        delay:500,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Fast Leaner")]),_c('h3',{directives:[{name:"anime",rawName:"v-anime",value:({
        translateX: '-150%',
        duration: 9000,
        delay:2000,
        easing: 'easeInOutSine',
        loop: true,
      }),expression:"{\n        translateX: '-150%',\n        duration: 9000,\n        delay:2000,\n        easing: 'easeInOutSine',\n        loop: true,\n      }"}]},[_vm._v("Inventive")])])])}
var staticRenderFns = []

export { render, staticRenderFns }